module.exports = __webpack_public_path__ + "static/media/student_handbook.27a24770.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/mariachi/student_handbook.pdf
// module id = 208
// module chunks = 0